import { useEffect } from 'react';

import { isModalOpen } from 'src/utils/is-modal-open';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import type { IConversation } from 'src/api/landlord-messages-api';
import type { IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context/types';

type Props = {
    focusedConversation?: IConversation;
    selectedConversations: Array<IConversation | IConversationMatchWithChannel>;
    setSelectedConversations: React.Dispatch<React.SetStateAction<Array<IConversation | IConversationMatchWithChannel>>>;
};

/**
 * Unselect all conversations when escape is pressed.
 */
export const useDeselectConversationWithEscape = ({
    focusedConversation,
    selectedConversations,
    setSelectedConversations
}: Props) => {

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && selectedConversations.length > 0 && !isModalOpen()) {
                analyticsClient.track(AnalyticsEvent.SHORTCUT_KEY_USED, {
                    page: 'Conversations',
                    key: 'Escape',
                });

                event.preventDefault();
                setSelectedConversations([]);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [focusedConversation, setSelectedConversations]);
};
